import { Button } from 'app/shared/button';
import GmModal from 'app/shared/modal/modal';
import { PermissionsContext } from 'contexts/permissions';
import React, { useContext, useState } from 'react';
import { IntegrationConfiguration } from '../../configurations';
import alert_icon from 'assets/images/alert.png';
import styles from '../item.module.css';

export const MobilePushItem = () => {
  const { permissions } = useContext(PermissionsContext);
  const [show_config_modal, setShowConfigModal] = useState(false);

  return (
    <>
      <div className={styles.card}>
        <div>
          <div className={styles.cardHeader}>
            <div className={styles.avatar}>
              <img src={alert_icon} alt="Mobile Push" />
            </div>
            <span className={styles.bold}>Mobile Push</span>
          </div>
          <div className={styles.cardBody}>
            <p>Deliver real-time notifications to your customers' mobile devices.</p>
          </div>
        </div>
        <div className={styles.extrasWrapper}>
          <Button
            text="Configure"
            className={styles.actionButton}
            onClick={() => setShowConfigModal(true)}
            disabled={!permissions['integration:create']}
          />
        </div>
      </div>
      <GmModal
        bodyClassName={styles.configModal}
        show_title
        show_modal={show_config_modal}
        title="Configure Mobile Push"
        onClose={() => setShowConfigModal(false)}
      >
        <IntegrationConfiguration module_data={{ code: 'mobi_push' }} />
      </GmModal>
    </>
  );
};
